import { render, staticRenderFns } from "./TableCreate.vue?vue&type=template&id=046d5ee3&scoped=true"
import script from "./TableCreate.vue?vue&type=script&lang=js"
export * from "./TableCreate.vue?vue&type=script&lang=js"
import style0 from "./TableCreate.vue?vue&type=style&index=0&id=046d5ee3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d5ee3",
  null
  
)

export default component.exports